import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";

import Stacks from "../components/Stacks";
import ArrowLeft from "../components/ArrowLeft";
import ArrowRight from "../components/ArrowRight";
import Experience from "../components/Experience";
import Footer from "../components/Footer";
import { fetchData } from "../utils/fetchData";

const Skill = () => {
  const [skills, setSkills] = useState([]);
  const [experiences, setExpirences] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [animateCard, setanimateCard] = useState({ y: 0, opacity: 1 });
  const URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchSkill = async () => {
      let skillData = [];
      let experienceData = [];
      skillData = await fetchData(`${URL}/stacks`);
      experienceData = await fetchData(`${URL}/experiences`);
      setSkills(skillData);
      setExpirences(experienceData);
      setIsLoading(false);
      console.log("about skills", skillData);
    };

    fetchSkill();
  }, []);

  return (
    <motion.div
      className="app__skills"
      id="skills"
      whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div class="app__projects-heading">
        <div class="projects__heading-text">
          <h2 class="head-text">
            <span class="p-ctext">#</span>Skills
          </h2>
          <div class="horizontal-line"></div>
        </div>
      </div>
      <div class="app_skills-container">
        <div class="shapes">
          <div class="skill-line">
            {skills.map((skill) => (
              <Stacks skill={skill} />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Skill;
